const BASE_DISPLAY_NAMES = {
  A: "Di Brownie",
  B: "DSSO",
};

export const BASE_ALL_LABEL = "Di Brownie + DSSO";

export function normalizeBaseDisplayKey(value) {
  const raw = String(value || "").trim().toUpperCase();
  if (!raw) return "";
  const normalized = raw.replace(/^BASE\s+/, "").trim();
  if (normalized === "A" || normalized === "B" || normalized === "ALL") return normalized;
  return raw;
}

export function formatBaseLabel(value, options = {}) {
  const {
    allLabel = BASE_ALL_LABEL,
    emptyLabel = "---",
    includeCode = false,
  } = options;

  const key = normalizeBaseDisplayKey(value);
  if (!key) return emptyLabel;
  if (key === "ALL") return allLabel;

  const name = BASE_DISPLAY_NAMES[key];
  if (name) return includeCode ? `${name} (${key})` : name;

  return String(value || emptyLabel);
}

export function formatBaseList(values, options = {}) {
  const {
    separator = " + ",
    allLabel = BASE_ALL_LABEL,
    emptyLabel = "---",
    includeCode = false,
  } = options;

  const list = Array.isArray(values) ? values : String(values || "").split(/[+,]/);
  const normalized = Array.from(
    new Set(
      list
        .map((item) => normalizeBaseDisplayKey(item))
        .filter((item) => item === "A" || item === "B" || item === "ALL")
    )
  );

  if (normalized.includes("ALL") || (normalized.includes("A") && normalized.includes("B"))) return allLabel;
  if (normalized.length === 0) return emptyLabel;
  return normalized.map((item) => formatBaseLabel(item, { allLabel, emptyLabel, includeCode })).join(separator);
}

export const baseFilterOptions = [
  { value: "ALL", label: BASE_ALL_LABEL },
  { value: "A", label: BASE_DISPLAY_NAMES.A },
  { value: "B", label: BASE_DISPLAY_NAMES.B },
];

export const baseOnlyOptions = baseFilterOptions.filter((option) => option.value !== "ALL");
